// Material
import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

const Background = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '125px',

  backgroundColor: theme.palette.primary.main,
  borderRadius: '0 0 10px 10px',

  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,

  '&:before': {
    width: '100%',
    height: '100%',

    content: "''",
    position: 'absolute',
    top: 0,
    left: 0,
    backgroundSize: '125%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',

    opacity: 0.4,
  },
}))
export function MyAccountBackground() {
  return <Background />
}
